import * as React from 'react';

import * as styles from './InfrastructureLegendSection.css';

export const InfrastructureLegendSection: React.FunctionComponent = ({ children }) => (
  <div className={styles['container']}>{children}</div>
);
